import React from "react";
import { MountainSnowIcon, UtensilsIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { TalaveraDivider } from "../components/culture/TalaveraDivider";
import { CelebrationSection } from "../components/home/CelebrationSection";
import { CultureStory, type StoryStyle } from "../components/home/CultureStory";
import { HeroReel } from "../components/home/HeroReel";
import { TacoStory } from "../components/home/TacoStory";
import { LocationCards } from "../components/LocationCards";
import { useSite } from "../context/SiteContext";
export function HomePage({
  storyStyle = "highlight"
}: {
  storyStyle?: StoryStyle;
}) {
  const {
    t
  } = useSite();
  return <>
      <HeroReel data-id="element-515" data-mp="31z269cicwb6u" />
      <TacoStory data-id="element-516" data-mp="31ykd4oqzqd35" />
      <CultureStory variant={storyStyle} data-id="element-517" data-mp="31y0x5dkwhyrr" />
      <TalaveraDivider data-id="element-518" data-mp="2ea12i2kgxo7w" />
      <CelebrationSection data-id="element-519" data-mp="2e97u6x5v2qnn" />

      <section id="locations" className="scroll-mt-24 bg-ivory px-5 py-20 sm:px-8 sm:py-28" data-id="element-520" data-mp="2e8gc8p56srfu">
        <div className="mx-auto max-w-7xl" data-id="element-521" data-mp="29aess33umq3u">
          <div className="mb-10 max-w-2xl" data-id="element-522" data-mp="2aov3wwnml7vq">
            <h2 className="font-serif text-4xl font-bold leading-[1] text-agavedeep sm:text-6xl" data-id="element-523" data-mp="2ao3jmhzhawkr">
              {t("Two kitchens. One warm welcome.", "Dos cocinas. Una cálida bienvenida.")}
            </h2>
          </div>
          <LocationCards data-id="element-524" data-mp="2jhyorq0lon0e" />
        </div>
      </section>

      <section className="bg-agavedeep px-5 py-20 text-cream sm:px-8 sm:py-28" data-id="element-525" data-mp="2ogjeuwm51qb4">
        <div className="mx-auto max-w-4xl text-center" data-id="element-526" data-mp="1rqai9k4i6uph">
          <MountainSnowIcon className="mx-auto h-9 w-9 text-marigold" aria-hidden="true" data-id="element-527" data-mp="1rrtyjaq5t5r9" />
          <h2 className="mx-auto mt-5 max-w-3xl font-serif text-4xl font-bold leading-[1] sm:text-5xl" data-id="element-528" data-mp="1vs4dhcvxj6i9">
            {t("Exploring Teton Valley? Make Agave Part of the Journey.", "¿Explorando Teton Valley? Haz de Agave parte del viaje.")}
          </h2>
          <p className="mx-auto mt-6 max-w-3xl leading-8 text-cream/80" data-id="element-529" data-mp="3c5cfv7hmaocl">
            {t("Between scenic drives, days at Grand Targhee, and mountain adventures near the Grand Teton area, join us in Driggs or Victor. We welcome locals and visitors traveling from Jackson Hole for skiing, hiking, biking, and time together around the table.", "Entre recorridos panorámicos, días en Grand Targhee y aventuras cerca del área de Grand Teton, visítanos en Driggs o Victor. Recibimos a residentes y visitantes de Jackson Hole que vienen a esquiar, caminar, andar en bicicleta y compartir alrededor de la mesa.")}
          </p>
          <Link to="/locations" className="mt-8 inline-flex min-h-12 items-center gap-2 rounded-full bg-marigold px-6 font-bold text-agavedeep transition-colors hover:bg-sunflower" data-id="element-530" data-mp="23rqwpdshyze6">
            <UtensilsIcon className="h-4 w-4" aria-hidden="true" data-id="element-531" data-mp="2dodhk2ktpqg7" />
            {t("Plan your visit", "Planea tu visita")}
          </Link>
        </div>
      </section>
    </>;
}